module.exports = __webpack_public_path__ + "static/hyrmed-01-a77631fb241e1678b3213e12843d0528.png";